<template>
    <cogi-modal :visible="visible">
        <slot></slot>
        <div>
            <cogi-button text="Oui" style="display: inline-block" cssClassButton="suivant" @click="yes" />
            <cogi-button text="Non" style="display: inline-block" cssClassButton="suivant" @click="no" />
        </div>
    </cogi-modal>
</template>

<script lang="ts" setup>
    import { ref } from 'vue'
    import CogiButton from '../CogiButton.vue'
    import CogiModal from './CogiModal.vue'

    const visible = ref(false)

    let resolveEvent: (result: boolean) => void

    const showDialog = async (): Promise<boolean> => {
        const promise = new Promise((resolve: (result: boolean) => void) => {
            resolveEvent = resolve
        })

        visible.value = true
        let result = await promise
        visible.value = false
        return result
    }

    function yes() {
        resolveEvent(true)
    }

    function no() {
        resolveEvent(false)
    }

    defineExpose({ showDialog })
</script>
